import { VisitResponse, CreateVisit } from 'src/store-redux/siteUpload/siteUploadStore.types';
import { faker } from '@faker-js/faker';

type UploadVisitMockProps = {
  data: CreateVisit;
  clinicalTrialId: string;
  siteId: string;
};

export const uploadVisitMock = (
  props: UploadVisitMockProps
): Promise<{ data: VisitResponse }> => {
  const responseData: VisitResponse = {
    id: '2f532d56-e3ef-4177-b0cf-f53b50fcd373',
    ...props.data,
    clinicalTrialId: props.clinicalTrialId,
    siteId: props.siteId,
    visitName: faker.lorem.word(),
  };

  return Promise.resolve({ data: responseData });
};
